// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoItem_container__2Hr40","children":"InfoItem_children__2KNdx","label":"InfoItem_label__2cwKs","description":"InfoItem_description__36K_9"};